<template>
<div class="login height100vh width100vh" v-bind:style="{'background-image': 'url(' + img + ')'}">
  <div class="row container-fluid">
    <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3 margin-top-2Point5Perc padding-left-3Point4Perc">
      <img :src="iplLogo" alt="imgedit" class="img-responsive cursor-pointer height-width">
    </div>
  </div>
  <login-form class="center"></login-form>
  <!-- <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 margin-Top-3Perc">
     <div class="col-lg-12">
        <Copyright-Element class="footer"></Copyright-Element>
     </div>
  </div> -->
  <div class="row container-fluid footer padding-right-0Perc">
    <div class="col-xs-5 col-sm-4 col-md-4 col-lg-4 text-color-white font-size-12Px text-align-left padding-left-46px">&copy;{{copyright}}</div>
    <div class="col-xs-1 col-sm-4 col-md-4 col-lg-4"></div>
    <div class="col-xs-6 col-sm-4 col-md-4 col-lg-4 text-color-white font-size-12Px padding-right-0Perc">
      <span class="col-xs-5 col-sm-5 col-md-5 col-lg-6"></span>
      <span class="col-xs-4 col-sm-3 col-md-3 col-lg-3 padding-left-0Perc padding-right-0Perc cursor-pointer"><a href="https://www.mentora.institute/termsofuse-mentora" target="_blank">Terms of Use</a></span> 
      <span class="col-xs-3 col-sm-4 col-md-4 col-lg-3 cursor-pointer padding-left-0Perc text-align-left"><a href="https://www.mentora.institute/privacypolicy-mentora" target="_blank">Privacy Policy</a></span></div> 
    </div>
  </div>
</template>

<script>
import LoginForm from '@/components/LoginForm'
import CopyrightElement from '@/components/CopyrightElement' // copyright Menu
import image from '../assets/images/bgimage.png'
import iplLogo from '../assets/images/ipl-logo-orange.svg'
require('bootstrap/dist/css/bootstrap.min.css')

export default {
  data () {
    return {
      img: image,
      iplLogo: iplLogo,
      copyright: ' 2024 Mentora Institute. All rights reserved.'
    }
  },
  components: {
    'login-form': LoginForm,
    'Copyright-Element': CopyrightElement
  },
  name: 'login'
}
</script>

<style scoped>
.margin-Top-3Perc{
  margin-top: 3% !important;
}
/* Using Only for footer */
.footer{
  position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    /* background-color: red; */
    /* color: white; */
    text-align: center;
    margin-bottom: 1%;
    font-size: 12px;
}
.height100vh{
  height:100vh;
  background-repeat: no-repeat;
  background-position: center;
}
.width100vh{
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  widows: 100%;
  overflow-x: hidden;
}

.text-color-white{
  color:white;
}
.footer{
  /* position: fixed; */
    /* left: 0; */
    bottom: 0;
    /* width: 18%; */
    /* background-color: red; */
    /* color: white; */
    /* text-align: center; */
    margin-bottom: 1%;
    font-size: 12px;
}
.color-red{
  border: 1px solid red;
}
.text-align-left{
  text-align: left;
}
.text-align-right{
  text-align: right;
}
.font-size-12Px{
  font-size:12px;
}
.footer {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    /* text-align: center; */
}
.padding-right-0Perc{
  padding-right:0%;
}
.margin-top-2Point5Perc{
  margin-top:2.5%;
}
.padding-left-15Px{
  padding-left:15px;
}
.padding-left-46px{
  padding-left:46px;
}
.cursor-pointer {
  cursor: pointer;
}
a {
  color: white;
  text-decoration: none;
}
a:link {
  color: white;
  text-decoration: none;
}
a:visited {
  color: white;
  text-decoration: none;
}
a:hover {
  color: white;
  text-decoration: none;
}
a:active {
  color: white;
  text-decoration: none;
}
.padding-left-0Perc{
  padding-left: 0%;
}
.center {
    margin: auto;
    width: 50%;
    /* border: 3px solid green; */
    padding: 10px;
}
.height-width{
  width: 65%;
  height:auto;
}
.padding-left-3Point4Perc{
  padding-left:3.4%;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login.vue